import styled from 'styled-components';
import { colors } from '../../assets/variables';
const Wrap = styled.div`
  display: flex;
  justify-content: center;
  flex-basis: 100%;
  margin: 32px 0px;
  background: linear-gradient(
    182.39deg,
    #bfecff -11.44%,
    #eefdff 35.43%,
    #ffffff 96.07%
  );
`;
const Card = styled.div`
  border-radius: 10px;
  background: #a5f3fd;
  align-items: center;
  justify-content: center;
  padding: 32px;

  width: 100%;
`;
const Line = styled.hr`
  margin-top: 32px;
  border-top: 1px solid ${colors.baseDark};
`;
export default { Wrap, Card, Line };
